import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import * as views from './views'
import { branding } from './constants/branding.constants'
import { ThemeProvider } from '@material-ui/styles'
import createTheme from './helpers/theme.helper'
import CssBaseline from '@material-ui/core/CssBaseline'
import AuthenticationProvider from './providers/authenticationProvider'
import userService from './services/auth.service'
import store from './store'
import ProtectedRoute from './components/routing/protectedRoute'
import SignInCallback from './callbacks/signInCallback'
import SignOutCallback from './callbacks/signOutCallback'
import SignInSilentCallback from './callbacks/signInSilentCallback'
import NoAccess from './pages/noAccess'
import Oops from './pages/oops'
import { routingConstants } from './constants/routing.constants'
import { makeStyles } from '@material-ui/core/styles'

function App() {
    const theme = createTheme(branding)

    return (
        <>
            <CssBaseline />
            <AuthenticationProvider userService={userService} store={store}>
                <ThemeProvider theme={{ ...theme }}>
                    <Router>
                        <Switch>
                            <ProtectedRoute
                                exact
                                path='/'
                                component={views.HomePage}
                                serviceSelectedRequired={false}
                            />
                            <ProtectedRoute
                                exact
                                path={
                                    routingConstants.paths.serviceConfiguration
                                }
                                key={
                                    routingConstants.paths.serviceConfiguration
                                }
                                component={views.ServiceConfigurationPage}
                            />
                            <ProtectedRoute
                                exact
                                path={routingConstants.paths.userConfiguration}
                                key={routingConstants.paths.userConfiguration}
                                component={views.UserConfigurationPage}
                            />
                            <ProtectedRoute
                                exact
                                path={
                                    routingConstants.paths.contentConfiguration
                                }
                                key={
                                    routingConstants.paths.contentConfiguration
                                }
                                component={views.ContentConfigurationPage}
                            />
                            <ProtectedRoute
                                exact
                                path={
                                    routingConstants.paths
                                        .authenticationConfiguration
                                }
                                key={
                                    routingConstants.paths
                                        .authenticationConfiguration
                                }
                                component={
                                    views.AuthenticationConfigurationPage
                                }
                            />
                            <ProtectedRoute
                                exact
                                path={
                                    routingConstants.paths
                                        .rolePermissionGroupConfiguration
                                }
                                key={
                                    routingConstants.paths
                                        .rolePermissionGroupConfiguration
                                }
                                component={
                                    views.RolePermissionGroupConfigurationPage
                                }
                            />
                            <Route
                                exact
                                path='/signin-oidc'
                                component={SignInCallback}
                            />
                            <Route
                                exact
                                path='/signout-oidc'
                                component={SignOutCallback}
                            />
                            <Route
                                exact
                                path='/silent-oidc'
                                component={SignInSilentCallback}
                            />
                            <Route path='/access' component={NoAccess} />
                            <Route path='*' component={Oops} />
                        </Switch>
                    </Router>
                </ThemeProvider>
            </AuthenticationProvider>
        </>
    )
}

export const useGlobalStyles = makeStyles(theme => ({
    tableTitle: {
        color: theme.variables.lightGrey,
        fontSize: '12px',
    },
    utilityMenuBadge: {
        marginRight: '1rem',
    },
    noBorderRadius: {
        borderRadius: '0',
    },
    tableContentHeader: {
        marginTop: '1rem',
        marginBottom: '0.5rem',
    },
    tableContentHeaderSubHeader: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.8rem',
        marginTop: '0',
        marginBottom: '1rem',
    },
    tableContentHeaderIcon: {
        width: '0.8em',
        height: '0.8em',
        marginLeft: '0.5rem',
    },
    /* show td and th on 1 row, add to table, table header or table body */
    tableNoWrap: {
        '& td, & th': {
            whiteSpace: 'nowrap',
        },
        /* align svg icons in the middle of cell */
        '& td svg, & th svg': {
            verticalAlign: 'middle',
            marginRight: '0.2em',
        },
    },
    tableHeader: {
        backgroundColor: theme.variables.lightestGrey,
        color: theme.variables.lightGrey,
        '& th, & td': {
            color: theme.variables.lightGrey,
            fontSize: '0.75rem',
        },
    },
    searchBox: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    searchContainer: {
        width: '100%',
        marginBottom: '0.5rem',
    },
    searchButton: {
        marginLeft: 'auto',
        marginBottom: '0.5rem',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.getContrastText(theme.palette.secondary.main),
        [theme.breakpoints.up('sm')]: {
            marginLeft: '0.5rem',
        },
    },
    fieldTitle: {
        fontSize: '.8rem',
        fontWeight: 'bold',
        color: theme.palette.grey[500],
        marginBottom: theme.spacing(1),
    },
    fieldContent: {
        fontSize: '.85rem',
        color: theme.palette.text.primary,
        fontWeight: 'bold',
    },
}))

export default App
